import React from 'react';
import ReactModal from 'react-modal';

interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
}

const Modal = ({ isOpen, onRequestClose, children }: ModalProps) => {
  return (
    <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} style={{
      overlay: {
        zIndex: 1000,
        backgroundColor: 'rgba(0, 0, 0, .5)',
      },
      content: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        border: 'none',
        padding: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    }}>
      {children}
    </ReactModal>
  );
};

export default Modal;

